import LegalContentRenderer from '../components/LegalContentRenderer';
import { refundContent } from '../mock/legalContent';

const RefundPolicy = () => <LegalContentRenderer content={refundContent} />;

export default RefundPolicy;
